// src/components/welcome/FeatureGrid.jsx
import React from "react";
import { Grid, Card, CardContent, Typography, Box } from "@mui/material";
import SecurityIcon from "@mui/icons-material/Security";
import TimelineIcon from "@mui/icons-material/Timeline";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";

const BINANCE_YELLOW = "#F0B90B";
const CARD_BG = "#263238"; // داكن مثل أقسام الصفحة
const ICON_SURFACE = "#37474F"; // طبقة الأيقونة الداكنة
const TEXT_MUTED = "#B0BEC5"; // نصوص ثانوية

// غلاف أيقونة بلمسات صفراء خفيفة (هايلايت)، بدون تلوين الأيقونة بالكامل
function IconWrap({ children }) {
  return (
    <Box
      sx={{
        width: 48,
        height: 48,
        borderRadius: "999px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: ICON_SURFACE,
        position: "relative",
        overflow: "hidden",
        boxShadow: `inset 0 0 0 1px rgba(255,255,255,0.06),
           0 6px 18px rgba(0,0,0,0.24),
           0 0 0 2px rgba(240,185,11,0.15)`, // هالة صفراء خفيفة حول الدائرة
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
        "&::after": {
          // لمسة صفراء مائلة، تعطي إحساس إضاءة بدون صبغ الدائرة كاملة
          content: '""',
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(135deg, rgba(240,185,11,0.28), transparent 45%)",
          pointerEvents: "none",
        },
        "&:hover": {
          transform: "translateY(-1px)",
          boxShadow: `inset 0 0 0 1px rgba(255,255,255,0.08),
             0 10px 22px rgba(0,0,0,0.32),
             0 0 0 2px rgba(240,185,11,0.22)`,
        },
      }}
    >
      {/* الأيقونة نفسها تبقى باللون الفاتح، اللمسات الصفراء تأتي من الخلفية والظل */}
      <Box sx={{ color: "#EAEFF2" }}>
        {React.cloneElement(children, { fontSize: "medium" })}
      </Box>
    </Box>
  );
}

const items = [
  {
    icon: <TimelineIcon />,
    title: "Spot & Perpetuals",
    desc:
      "Professional order types with ultra-smooth execution and intuitive UX.",
    keywords: "spot trading, perpetual futures, advanced orders",
  },
  {
    icon: <SecurityIcon />,
    title: "Multi-Layer Security",
    desc:
      "2FA, withdrawal allow-listing, encryption, and continuous risk monitoring.",
    keywords: "security, encryption, 2FA, AML, KYC",
  },
  {
    icon: <AutoGraphIcon />,
    title: "Analytics & Insights",
    desc:
      "Real-time market data, smart watchlists, and TradingView-style charts.",
    keywords: "market data, charts, analytics, insights",
  },
  {
    icon: <HeadsetMicIcon />,
    title: "24/7 Live Support",
    desc: "Live chat, ticketing system, and a comprehensive knowledge base.",
    keywords: "support, live chat, help center, knowledge base",
  },
];

export default function FeatureGrid() {
  return (
    <Grid container spacing={2}>
      {items.map((it, idx) => (
        <Grid item xs={12} sm={6} md={3} key={idx}>
          <Card
            sx={{
              height: "100%",
              bgcolor: CARD_BG,
              borderRadius: 2,
              border: "1px solid rgba(255,255,255,0.08)",
              boxShadow: "0 8px 24px rgba(0,0,0,0.35)",
              transition: "transform 0.2s ease, box-shadow 0.2s ease",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0 12px 30px rgba(0,0,0,0.45)",
              },
            }}
          >
            <CardContent sx={{ p: 2.5 }}>
              <Box
                sx={{
                  mb: 1.25,
                  display: "flex",
                  alignItems: "center",
                  gap: 1.25,
                }}
              >
                <IconWrap>{it.icon}</IconWrap>
                {/* لمسة صفراء صغيرة على العنوان: خط سفلي خفيف */}
                <Box
                  sx={{
                    ml: 0.5,
                    height: 3,
                    width: 22,
                    borderRadius: 2,
                    background: `linear-gradient(90deg, ${BINANCE_YELLOW}, rgba(240,185,11,0.2))`,
                  }}
                />
              </Box>

              <Typography
                variant="h6"
                sx={{ fontWeight: 800, color: "#FFFFFF", lineHeight: 1.2 }}
              >
                {it.title}
              </Typography>

              <Typography
                color="text.secondary"
                sx={{ mt: 0.75, color: TEXT_MUTED }}
              >
                {it.desc}
              </Typography>

              <Box
                sx={{
                  mt: 1.25,
                  opacity: 0.7,
                  fontSize: 12.5,
                  color: TEXT_MUTED,
                }}
              >
                {it.keywords}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
